/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlASN
 */
export interface ControlASN {
    /**
     * 
     * @type {string}
     * @memberof ControlASN
     */
    asn: string;
    /**
     * 
     * @type {string}
     * @memberof ControlASN
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof ControlASN
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlASN
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlASN
     */
    type: string;
}

/**
 * Check if a given object implements the ControlASN interface.
 */
export function instanceOfControlASN(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asn" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlASNFromJSON(json: any): ControlASN {
    return ControlASNFromJSONTyped(json, false);
}

export function ControlASNFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlASN {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asn': json['asn'],
        'domain': json['domain'],
        'name': json['name'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'type': json['type'],
    };
}

export function ControlASNToJSON(value?: ControlASN | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asn': value.asn,
        'domain': value.domain,
        'name': value.name,
        'route': value.route,
        'type': value.type,
    };
}

